import { useMutation } from '@tanstack/react-query';

import { uploadDocumentsInAnva } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useUploadDocumentAnva() {
  return useMutation({
    mutationFn: ({
      crmPartyId,
      crmPolicyId,
      link,
      filename,
      segmentCode,
      description,
      task,
    }: {
      crmPartyId: string;
      crmPolicyId?: string;
      link: string;
      filename: string;
      segmentCode: '11' | '12';
      description: string;
      task?: {
        description: string;
        dueDate?: string;
        assignedTo?: string;
      };
    }) =>
      uploadDocumentsInAnva(
        {
          params: {
            path: { anva_party_id: crmPartyId },
            query: {},
          },
          body: {
            link,
            filename,
            anva_policy_id: crmPolicyId,
            segment_code: segmentCode,
            ddi_document_type: '1',
            description,
            task: task
              ? {
                  description: task.description,
                  due_date: task.dueDate,
                  assigned_to: task.assignedTo,
                }
              : undefined,
          },
        },
        wgApi,
      ),
  });
}
